




























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerTmp from "./../../common/banner/bannerTop.vue";
import EffectTmp from "./../../common/effect_footer/effect_footer.vue";
@Component({
    components:{
        BannerTmp,EffectTmp
    }
})
export default class wisdomaffairIndex extends Vue {
    //向子组件传值
    //protected 修饰的属性或者方法是私有的，但它的子组件可以访问到
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_wisdom.png'),
        title: '智慧政务审批',
        subTitle: '轻松助力业务降本增效'
    };
    public list: any= [
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_1.png'), title: '业务数据孤岛', des: '审批平台未统一，业务&数据割裂。'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_2.png'), title: '审批繁琐', des: '业务办理、审核等环节复杂繁琐，存在重复无效操作。'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_3.png'), title: '管理复杂', des: '流程难以把控，上级监控困难且群众无法了解进度。'}
    ];

    public frontArr: any= [
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_6.svg'), number: 1, text: '申请人窗口提交审核材料'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_7.svg'), number: 2, text: '对申报材料进行形式审查'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_8.svg'), number: 3, text: '工作人员现勘查、专家论证'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_9.svg'), number: 4, text: '工作人员反馈结果至平台'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_10.svg'), number: 5, text: '申请人到窗口领取证件或驳回通知书'}
    ];
    public afterArr: any= [
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_11.svg'), number: 1, text: '申请人线上提交审核材料'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_12.svg'), number: 2, text: '自动审核材料是否齐全',
        icon: require('../../../assets/images/solution/OCR.svg'),iconTwo: require('../../../assets/images/solution/NLP.svg')},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_13.svg'), number: 3, text: '工作人员现场勘查、专家论证'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_14.svg'), number: 4, text: '自动办理相关资质并同步结果至多系统'},
        {imgUrl: require('../../../assets/images/solution/wisdom/wisdom_15.svg'), number: 5, text: '审批通过寄递许可证并同步结果至多系统'}
    ];

    mounted(){
       
    }

}

